import { Button } from 'antd';
import styled from 'styled-components';

export const RecordButton = styled(Button)`
  &&& {
    background-color: #18212c;
    color: var(--white);
    font-weight: 700;

    :where(.css-dev-only-do-not-override-15emhpp).ant-btn-variant-text:not(
        :disabled
      ):not(.ant-btn-disabled):hover {
      background: #18212c;
    }
  }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(24, 33, 44, 0.4);
  z-index: 1000;
  align-items: flex-end;
`;

export const RecordPlayer = styled.div`
  padding-block: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 130px;
  background-color: var(--white);
  width: 100%;
`;

export const PlayPauseButton = styled(Button)`
  width: 41px;
  height: 41px;
  border-radius: 50%;
  background-color: #f5f6f8;
`;

export const RecordMinuteIcon = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #ff4c4e;
`;
